export class ExtendableError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = this.constructor.name;
    // restore prototype
    // See https://stackoverflow.com/questions/41102060/typescript-extending-error-class
    Object.setPrototypeOf(this, new.target.prototype);
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }
}
